export default __webpack_public_path__ + "svg/who/eoi.svg?c9efd8ce";